import React, { useEffect, useState } from 'react'

export default function Ajankohtaista() {
    const [ajankohtaista, setAjankohtaista] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    // const URL = 'http://localhost/KirppisRuusunenBackEnd/ajankohtaista.php';
    const URL = 'https://kirppisruusunen.fi/ajankohtaista/ajankohtaista.php';
    useEffect(() => {
        let status = 0;
        fetch(URL)
            .then(res => {
            status = parseInt(res.status);
            return res.json();
              })
              .then(
                (res) => {
                  if (status === 200) {
                    setAjankohtaista(res);
                    if(res.length === 0) {
                      setAjankohtaista([{ajankohtaista_sisalto: "Ei ajankohtaisia ilmoituksia vielä!", kirjoitettu: ""}])
                    }
                    setIsLoaded(true)
                    
                  } else {
                    alert(res.error);
                    setIsLoaded(false);
                  }
        
                }, (error) => {
                  alert("Virhe ajankohtaista laatikon päivittämisessä.");
                }
              )
        
        
    }, [])

    if (!isLoaded) {
        return (
            <div className="row justify-content-center pt-5">
            <div className="col-auto d-block">
                <i className="fa fa-spinner fa-spin fa-3x" aria-hidden="true"></i>
            </div>
            <h2 className="col-auto d-block">Ladataan...</h2>
            </div>
        )
    } else {
    return (
        <div className="mx-lg-2">
            <h2 className="text-center fontti mb-4 pt-1">Ajankohtaista</h2>
            <section className="artikkelit_AK m-auto loota1 ">
            <h4 className="fontti pl-1 ps-4 p-3 mt-1 bold "><u>Viimeisimmät</u>
            <span style={{color: "black"}} className="p-2"><i className="fas fa-calendar-alt"></i></span></h4>

            <ul className="loota2 py-2">
            {ajankohtaista.map(ajankohtaista => (
                <li key={ajankohtaista.ajankohtaista_sisalto + ajankohtaista.kirjoitettu} className="mx-2 mb-2">{ajankohtaista.ajankohtaista_sisalto}<span className="text-muted p-3">{ajankohtaista.kirjoitettu}</span></li>
            ))}
            </ul>
            </section>
        </div>
    )
}
}
